import React, { useEffect, useState } from 'react';
import './Reviews.css';
import { fetchData } from '../../config/dataService';
import config from '../../config/config';

function ReviewCard({ review }) {
  const imageUrl = review.image
    ? `${config.S3_IMAGES_BASE_URL}/reviewImages/${review.image}`
    : null;

  // The clickable header wraps image + location name.
  // If there's no url, render as a plain div instead of an anchor.
  const HeaderWrapper = ({ children }) =>
    review.url ? (
      <a
        href={review.url}
        target="_blank"
        rel="noopener noreferrer"
        className="review-card__link-header"
      >
        {children}
      </a>
    ) : (
      <div className="review-card__link-header review-card__link-header--no-url">
        {children}
      </div>
    );

  return (
    <article className="review-card fade-up">

      {/* ── Clickable header: image + location ── */}
      <HeaderWrapper>
        {imageUrl && (
          <div className="review-card__image-wrap">
            <img
              src={imageUrl}
              alt={review.location || ''}
              className="review-card__image"
            />
          </div>
        )}
        {!imageUrl && (
          <div className="review-card__image-placeholder">
            <span>📍</span>
          </div>
        )}
        <div className="review-card__location-label">
          {review.location}
          {review.url && (
            <span className="review-card__link-icon">↗</span>
          )}
        </div>
      </HeaderWrapper>

      {/* ── Body text ── */}
      <p className="review-card__body">{review.body}</p>

    </article>
  );
}

export default function Reviews() {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    fetchData('reviews')
      .then(setData)
      .catch(setError)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading-state">Loading reviews…</div>;
  if (error)   return <div className="error-state">Could not load reviews. Please try again.</div>;

  const { title = 'Restaurant Reviews', subtitle, reviews = [] } = data || {};

  return (
    <main className="reviews">
      <div className="container">
        <div className="reviews__header">
          <h1 className="section-title">{title}</h1>
          {subtitle && <p className="section-subtitle">{subtitle}</p>}
          <div className="divider" />
        </div>

    

        <div className="reviews__grid">
          {reviews.map((review, i) => (
            <ReviewCard key={i} review={review} />
          ))}
        </div>
      </div>
    </main>
  );
}
